// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2DYz6","avatar":"style_avatar__1YnkU"};